import Chart from 'chart.js'

Chart.defaults.global.defaultFontFamily = '"Outfit", "Roboto", sans-serif'
Chart.defaults.global.defaultFontSize = 12
Chart.defaults.global.defaultFontColor = '#8892A4'

export default Chart
